export default "__VITE_ASSET__B1f3VeBG__"